import React from "react";
import Select from "react-select";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { truncate } from "lodash";

const JobMilestonePicker = ({
  jobNumber,
  value,
  onChange,
  placeholder = "Select Job Milestone...",
  ...props
}) => {
  const { backendUrl } = useAuth();

  const { data: jobMilestone, isLoading, error } = useQuery(
    ["jobMilestone", jobNumber],
    async () => {
      if (!jobNumber) return [];
      const response = await fetch(
        `${backendUrl}/api/job/milestones/${jobNumber}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch job milestones");
      }
      const { data } = await response.json();
      return data;
    },
    {
      enabled: !!jobNumber,
      staleTime: 0,
    }
  );

  const options =
    (Array.isArray(jobMilestone) &&
      jobMilestone?.map(milestone => ({
        ...milestone,
        value: milestone.milestoneNumber,
        label: `${truncate(milestone.milestone, {
          length: 50,
        })}`,
      }))) ||
    [];

  // Find the selected option to get the proper label
  const selectedOption = options.find(option => option.value === value) || null;

  return (
    <Select
      value={selectedOption}
      onChange={onChange}
      options={options}
      isLoading={isLoading}
      isDisabled={!jobNumber || isLoading}
      placeholder={placeholder}
      isClearable
      isSearchable
      loadingMessage={() => "Loading job milestones..."}
      noOptionsMessage={() =>
        error ? "Error loading milestones" : "No milestones found"
      }
      classNamePrefix="form-select"
      {...props}
    />
  );
};

export default JobMilestonePicker;
